/**
 * Ações do reCAPTCHA. Os valores TÊM que ser idênticos às constantes de AcoesCaptcha no backend
 * (DrCobranca.Infra/Shared/Captcha/AcoesCaptcha.cs) — o siteverify compara a ação declarada aqui
 * com a esperada lá, e divergência recusa o token.
 */
export const AcoesCaptcha = {
  loginIdentificacao: 'login_identificacao',
  login: 'login',
  recuperarSenha: 'recuperar_senha',
  alterarSenha: 'alterar_senha',
  onboard: 'onboard',
  enviarToken: 'enviar_token',
  consultaDivida: 'consulta_divida',
  faleConosco: 'fale_conosco',
};

/**
 * Mapa de rota → ação. O interceptor consulta por trecho da URL, então a chave é um pedaço do
 * caminho, comparado sem diferenciar maiúsculas. Rota que não estiver aqui segue sem token.
 *
 * A ordem importa: o primeiro trecho que casar vence. Por isso os caminhos mais específicos
 * (`autenticacao/alterarsenha`) vêm antes dos mais genéricos (`v2/autenticacao`).
 */
export const ROTAS_CAPTCHA: Array<{ trecho: string; acao: string }> = [
  { trecho: 'autenticacao/recuperarsenha', acao: AcoesCaptcha.recuperarSenha },
  { trecho: 'autenticacao/consultacontastokensenha', acao: AcoesCaptcha.alterarSenha },
  { trecho: 'autenticacao/alterarsenhamultiplascontas', acao: AcoesCaptcha.alterarSenha },
  { trecho: 'autenticacao/consultarcontastokensenha', acao: AcoesCaptcha.alterarSenha },
  { trecho: 'autenticacao/alterarsenha', acao: AcoesCaptcha.alterarSenha },
  { trecho: 'autenticacao/enviartokensvalidacao', acao: AcoesCaptcha.enviarToken },
  { trecho: 'autenticacao/usuariopossuisenhanula', acao: AcoesCaptcha.loginIdentificacao },
  { trecho: 'autenticacao/consultarusuarioscadastrosenha', acao: AcoesCaptcha.loginIdentificacao },
  { trecho: 'autenticacao/consultarcodigousuarioemailcpfcelular', acao: AcoesCaptcha.loginIdentificacao },
  { trecho: 'credor/incluiratualizarcredoronboard', acao: AcoesCaptcha.onboard },
  { trecho: 'credor/incluirsenhacredoronboard', acao: AcoesCaptcha.onboard },
  { trecho: 'credor/enviartokensvalidacao', acao: AcoesCaptcha.enviarToken },
];

/** Descobre a ação de uma URL, ou null se a rota não exige captcha. */
export function acaoDaRota(url: string, metodo: string): string | null {
  const caminho = (url || '').toLowerCase();

  const rota = ROTAS_CAPTCHA.find(x => caminho.indexOf(x.trecho) >= 0);
  if (rota) {
    return rota.acao;
  }

  // O login do SSO é POST na raiz de v2/autenticacao — não dá para distinguir por trecho de
  // caminho, porque o GET da mesma raiz é a etapa de identificação.
  if (/\/v2\/autenticacao\/?(\?.*)?$/.test(caminho)) {
    return metodo === 'POST' ? AcoesCaptcha.login : AcoesCaptcha.loginIdentificacao;
  }

  // GET v2/autenticacao/{usuario} — etapa 1 (identificação). Só que várias rotas nomeadas da v2
  // têm a mesma forma de um segmento só, e essas não levam captcha.
  const ROTAS_V2_SEM_CAPTCHA = [
    'obterchaveseguranca',
    'autenticarusuariofirebase',
    'autosigninapp',
    'autosigninapp2safecredit',
    'obtertokenapp',
    'token',
    'grupocredor',
  ];

  const v2 = /\/v2\/autenticacao\/([^/?]+)\/?(\?.*)?$/.exec(caminho);
  if (v2 && metodo === 'GET' && ROTAS_V2_SEM_CAPTCHA.indexOf(v2[1]) < 0) {
    return AcoesCaptcha.loginIdentificacao;
  }

  return null;
}
